import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const GET_SECURITY_USER_STOCKS = 'GET_SECURITY_USER_STOCKS';

const apiCall = createApiCall(GET_SECURITY_USER_STOCKS, params => ({
  endpoint: generateEndpoint({
    host: `/api/admin/security-user-stocks`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
